import React from 'react';
import classNames from 'classnames';
import { animated, SpringValues } from '@react-spring/web';
import { createPropsEqualsChecker } from './utils/create-props-equals-checker';
import { useEditorStore } from './editor-store';
import { useAnimatedBoundaries } from './utils/animated-boundaries.hook';

type BoundaryStyleValues = { x: number; y: number; width: number; height: number; opacity: number };

type AnimatedBoundaryViewProps = {
  style: SpringValues<BoundaryStyleValues>;
};

const AnimatedBoundaryView = ({ style }: AnimatedBoundaryViewProps) => {
  return (
    <animated.div
      className={classNames('absolute z-neue-boundary-insertion pointer-events-none rounded bg-neue-journey-bg-90')}
      style={style}
    />
  );
};

const MemoizedAnimatedBoundaryView = React.memo(
  AnimatedBoundaryView,
  createPropsEqualsChecker(['style'], 'AnimatedBoundaryView')
);

export const AnimatedBoundaryViews = () => {
  const reorderBoundary = useEditorStore((state) => state.reorderBoundary);
  const insertionBoundary = useEditorStore((state) => state.insertionBoundary);
  const boundaries = useEditorStore((state) => state.layout.boundaries);
  const activeBoundaryKey = (reorderBoundary || insertionBoundary)?.boundaryKey || null;

  const { springs } = useAnimatedBoundaries(boundaries, activeBoundaryKey);

  return (
    <>
      {springs.map((spring, i) => {
        return <MemoizedAnimatedBoundaryView key={`${i}`} style={spring} />;
      })}
    </>
  );
};

export const MemoizedAnimatedBoundaryViews = React.memo(
  AnimatedBoundaryViews,
  createPropsEqualsChecker([], 'AnimatedBoundaryViews')
);
